import { hasFlag } from 'country-flag-icons'
import * as flagStrings from 'country-flag-icons/string/1x1'
import { unescape } from 'es-toolkit'

/** Returns the square flag image data URL that matches the country code. Returns `null` if no flag was found. */
export const getSquareCountryFlagImageUrl = (countryCode: string) => {
	if (!hasFlag(countryCode) || !flagStrings[countryCode as keyof typeof flagStrings]) {
		console.warn(`Flag: ${countryCode} not found`)
		return null
	}

	return `data:image/svg+xml;base64,${btoa(unescape(flagStrings[countryCode as keyof typeof flagStrings]))}`
}
